// import eventsData from '../data/events.json'

export default class EventService {
  // eventsObjects = eventsData

  async getAllEvents () {
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest()
      request.open('GET', 'https://sweea.se/api/GetEvents.php', true)
      request.onload = function () {
        if (request.status >= 200 && request.status < 400) {
          // Success!
          const fetchedEvents = JSON.parse(request.responseText)
          const formattedEvents = fetchedEvents.map(event => ({
            id: event.event_id,
            date: event.event_date,
            description: event.event_description,
            location: event.event_location_name,
            city: event.event_location_city,
            link: event.event_location_url,
            fb: event.event_location_fb_url,
            ig: event.event_location_ig_url,
            map: event.event_location_map_url,
            booking: event.event_booking_url
          }))
          resolve(formattedEvents) // Resolve the promise with the formatted data
        } else {
          // Server returned an error
          console.log('error')
          reject(new Error('Server error')) // Reject the promise with an error
        }
      }
      request.onerror = function () {
        // Connection error
        console.log('connection error')
        reject(new Error('Connection error')) // Reject the promise with an error
      }
      request.send()
    })
  }

  sortEventsByDate (events) {
    return events?.sort((a, b) => {
      let da = new Date(a.date)
      let db = new Date(b.date)
      return da - db
    })
  }

  filterEvents (events) {
    return events?.filter(e => {
      const yesterday = new Date(new Date().getTime() - 24 * 60 * 60 * 1000)
      const eventDate = new Date(e.date).getTime()
      return eventDate > yesterday ? e : null
    })
  }

  trimDate (date) {
    return date !== null && date !== undefined ? date.split(' ')[0] : null
  }

  getUpcomingEvents (allEvents) {
    return this.sortEventsByDate(this.filterEvents(allEvents))
  }

  async getNextEvent () {
    const allAvents = await this.getAllEvents()
    const upcomingEvents = this.getUpcomingEvents(allAvents)
    return upcomingEvents[0]
  }
}
